import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { downloadCSV } from '@frontend/media-helpers';

const EMAIL_CSV_EXAMPLE_NAME = 'email-recipient-list-example';
const EMAIL_CSV_EXAMPLE_CONTENT = `
First Name,Last Name,Email,Preferred Name
John,Doe,john.doe@example.com,John
Tony,Dow,tony.dow@example.com,Homer
Bruce,Nolan,bruce.nolan@example.com,Bruce
Samuel,Zabaglione,samuel.zabaglione@example.com,Sam
`.trim();

const TEXT_CSV_EXAMPLE_NAME = 'email-recipient-list-example';
const TEXT_CSV_EXAMPLE_CONTENT = `
First Name,Last Name,Phone,Preferred Name
John,Doe,(555) 555-5555,John
Tony,Dow,333-567-7890,Homer
Bruce,Nolan,4445556666,Bruce
Samuel,Zabaglione,1-777-888-9999,Sam
`.trim();

export const downloadExampleCsv = (campaignType: CampaignType) => {
  if (campaignType === CampaignType.SMS) {
    downloadCSV(TEXT_CSV_EXAMPLE_CONTENT, TEXT_CSV_EXAMPLE_NAME);
  } else {
    downloadCSV(EMAIL_CSV_EXAMPLE_CONTENT, EMAIL_CSV_EXAMPLE_NAME);
  }
};
